<div class="modal-content" *ngIf="loaded">
  <div class="modal-header text-center p-3">
    <i aria-label="Close" (click)="handleClick({ close: true })" class="close pull-right align-middle fas fa-times"> </i>
    <h4 class="modal-title w-100">{{ 'modals.filters.title' | translate }}</h4>
  </div>
  <div class="modal-body">
    <form (ngSubmit)="submit()" (keydown.enter)="submit()">
      <div class="pt-2 settings">
        <ng-container *ngFor="let optionLine of options">
          <jhi-number-filter data-id-cypress="jhi-number-filter" *ngIf="isNumberFilter(optionLine)" [filter]="optionLine"></jhi-number-filter>
          <jhi-string-filter data-id-cypress="jhi-string-filter" *ngIf="isStringFilter(optionLine)" [filter]="optionLine"></jhi-string-filter>
          <jhi-date-filter *ngIf="isDateFilter(optionLine)" [filter]="optionLine"></jhi-date-filter>
          <jhi-datetime-filter *ngIf="isDateTimeFilter(optionLine)" [filter]="optionLine"></jhi-datetime-filter>
          <jhi-transporter-member-filter *ngIf="isCommercialFilter(optionLine)" [filter]="optionLine"></jhi-transporter-member-filter>
          <jhi-paiement-method-filter *ngIf="isPaymentMethodFilter(optionLine)" [filter]="optionLine"></jhi-paiement-method-filter>
          <jhi-delivery-status-filter *ngIf="isDeliveryStatusFilter(optionLine)" [filter]="optionLine"></jhi-delivery-status-filter>
          <jhi-refunded-status-filter *ngIf="isRefundedStatusFilter(optionLine)" [filter]="optionLine"></jhi-refunded-status-filter>
          <jhi-payment-status-filter *ngIf="isPaymentStatusFilter(optionLine)" [filter]="optionLine"></jhi-payment-status-filter>
          <jhi-sales-support-actions-attribute-filter *ngIf="isSalesSupportActionsAttributeFilter(optionLine)" [filter]="optionLine"></jhi-sales-support-actions-attribute-filter>
        </ng-container>
      </div>
    </form>
  </div>

  <!--Footer-->
  <div class="modal-footer justify-content-right">
    <jhi-bary-button (clickEvent)="handleClick({ cancel: true })" [label]="'modals.buttons.cancel' | translate" color="danger" class="mr-2"></jhi-bary-button>
    <jhi-bary-button data-id-cypress="btn-submit-filters" color="primary" [label]="'modals.buttons.submit' | translate" (clickEvent)="submit()"></jhi-bary-button>
  </div>
</div>
